import { useEffect, useState } from 'react';
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";

function useMegamenu(ref, menuItemsData, settings, isMobile)
{
    const [menuState, setMenuState] = useState({
        menuAnimClass: "",
        firstLevelActive: false,
        secondLevelActive: false,
        thirdLevelActive: false,
        navigationTitle: "",
        firstMenuTitle: "",
        firstMenuHandle: "",
        transitionClass: "",
        primaryLinksAnim: "",
        isSecondLevelVisible: false,
    });

    const showInitialWhenNoLinks = true;

    const [featuredImageBlocks, setFeaturedImageBlocks]: any = useState([]);

    const [firstMenuSubItem, setFirstMenuSubItem]: any = useState(null);
    const [hoveredLink, setHoveredLink]: any = useState(firstMenuSubItem);
    const [megaMenuRef, setMegaMenuRef]: any = useState(ref);
    const [menuItems, setMenuItems]: any = useState(menuItemsData);


    const updatedMenuItems = menuItems?.subMenuItems[0]?.links.map(link => {
        const titlePart = link.title?.split('|')[0].trim();
        return {
            ...link,
            title_without_classes: titlePart,
        };
    });
    const openMenu = useHeaderMenuStore((state) => state.openMenu)
    const closeMenu = useHeaderMenuStore((state) => state.closeMenu)

    const firstLevelLinks = updatedMenuItems || [];
    const defaultSecondLevelLinks = firstLevelLinks[0]?.links || [];

    const [secondLevelLinks, setSecondLevelLinks] = useState(settings.section.show_secondlevel_open_always ? defaultSecondLevelLinks : []);

    if (menuItems.length > 0 ){
        if (!isMobile) {
            setFirstMenuSubItem(menuItems?.subMenuItems[0]?.links[0]);
        }
    }

    const updateMenuState = (updates) => setMenuState((prevState) => ({ ...prevState, ...updates }));

    const handleFirstLevelClick = (link) => {
        if (link.links.length > 0) {
            updateMenuState({
                navigationTitle: link.title,
                transitionClass: "slide-out-left",
                firstLevelActive: false,
                secondLevelActive: true,
                isSecondLevelVisible: true,
                primaryLinksAnim: "slide-in-from-right",
            });
            window.dispatchEvent(new Event("megamenu-menu-open"));
        }
    };

    const getPadding = (data) => {
        return `px-[${data.padding_left_right_mobile}px]
        lg:px-[${data.padding_left_right_desktop}px]
        pt-[${data.padding_top_mobile}px]
        lg:pt-[${data.padding_top_desktop}px]
        pb-[${data.padding_bottom_mobile}px]
        lg:pb-[${data.padding_bottom_desktop}px]`;
    }


    const getInitialFeaturedImageBlocks = () =>
    {

        const filterTopAreaBlocks = menuItems.blocks.filter((item) => {
            const matchesSearch = item.type
                .toLowerCase()
                .includes('toparea');
            return matchesSearch;
        });

        return filterTopAreaBlocks.reduce((initialBlocks, block) =>
        {
            for (let i = 1; i <= 4; i++) {
                const imageKey = `image_${i}`;
                const mobileImageKey = `mobile_image_${i}`;
                const titleKey = `title_${i}`;
                const urlKey = `url_${i}`;
                const buttonTextKey = `button_text_${i}`;
                const buttonStyleKey = `button_text_style_${i}`;
                const buttonIcon = `icon_${i}`;

                if (block.settings[imageKey]) {
                    initialBlocks.push({
                        image: block.settings[imageKey],
                        mobile_image: block.settings[mobileImageKey],
                        title: block.settings[titleKey],
                        url: block.settings[urlKey],
                        button_text: block.settings[buttonTextKey],
                        layout: block.settings.button_layout,
                        button_style: block.settings[buttonStyleKey],
                        icon: block.settings[buttonIcon],
                    });
                }
            }

            return initialBlocks;
        }, []);
    };


    const updateFeaturedImageBlocks = (link) => {
        const filterImageBlocks = menuItems.blocks.filter((item) => {
            const matchesSearch = item.type
                .toLowerCase()
                .includes('images');
            return matchesSearch;
        });

        const updatedBlocks = filterImageBlocks?.reduce((blocks, block) => {
            if (block.settings.title === link.title_without_classes) {
                for (let i = 1; i <= 2; i++) {
                    const imageKey = `image_${i}`;
                    const mobileImageKey = `mobile_image_${i}`;
                    const titleKey = `title_${i}`;
                    const urlKey = `url_${i}`;
                    const buttonTextKey = `button_text_${i}`;
                    const buttonStyleKey = `button_text_style_${i}`;
                    const buttonIcon = `icon_${i}`;

                    if (block.settings[imageKey]) {
                        blocks.push({
                            image: block.settings[imageKey],
                            mobile_image: block.settings[mobileImageKey],
                            title: block.settings[titleKey],
                            url: block.settings[urlKey],
                            button_text: block.settings[buttonTextKey],
                            layout: block.settings.button_layout,
                            button_style: block.settings[buttonStyleKey],
                            icon: block.settings[buttonIcon],
                        });
                    }
                }
            }
            return blocks;
        }, []);
        setFeaturedImageBlocks(updatedBlocks);
    };

    const handleBackClick = () => {
        if (menuState.secondLevelActive) {
            updateMenuState({
                transitionClass: "slide-in-left",
                secondLevelActive: false,
                navigationTitle: menuState.firstMenuTitle,
                firstLevelActive: true,
                primaryLinksAnim: "slide-in-left",
            });

            const drawerElement = document.querySelector(
                ".megamenu__secondary--links",
            );
            if (drawerElement) {
                const handleAnimationEnd = () => {
                    updateMenuState({ isSecondLevelVisible: false });
                    drawerElement.removeEventListener("animationend", handleAnimationEnd);
                };
                drawerElement.addEventListener("animationend", handleAnimationEnd);
            }
        } else {
            window.dispatchEvent(new Event("megamenu-menu-close"));
            updateMenuState({
                primaryLinksAnim: "slide-out-to-right",
                menuAnimClass: "slide-out-to-right",
                isFirstLevelActive: true,
            });
            const drawerElement = document.querySelector(".megamenu__primary--links");
            if (drawerElement) {
                const handleAnimationEnd = () => {
                    updateMenuState({ isSecondLevelVisible: false });
                    drawerElement.removeEventListener("animationend", handleAnimationEnd);
                };
                drawerElement.addEventListener("animationend", handleAnimationEnd);
            }
        }
    };

    const handleMenuClose = () => {
        updateMenuState({
            primaryLinksAnim: "slide-out-to-right",
            menuAnimClass: "slide-out-left",
            firstLevelActive: false,
            secondLevelActive: false,
            isSecondLevelVisible: false,
        });
    };

    function onLinkHover (link) {
        setHoveredLink(link);


        if (link?.level <= 2) {
            setActiveLink(link.handle);
            // console.log('Hovered Link:', link);
            updateMenuState({
                firstMenuHandle: link.handle,
                firstLevelActive: true
            });

            setSecondLevelLinks(link?.links);
            updateFeaturedImageBlocks(link);
        }
        // openMenu('MEGAMENU');


        if (showInitialWhenNoLinks) {
            const filterImageBlocks = menuItems.blocks.filter((item) => {
                const matchesSearch = item.type
                    .toLowerCase()
                    .includes('images');
                return matchesSearch;
            });
            let hasFeaturedImages = false;

            const updatedBlocks = filterImageBlocks?.map((block, index) => {

                if (block.settings.title === link.title_without_classes) {
                    hasFeaturedImages = true;
                }
            });

            const filterTopAreaBlocks = menuItems.blocks.filter((item) => {
                const matchesSearch = item.type
                    .toLowerCase()
                    .includes('toparea');
                return matchesSearch;
            });
            if (!hasFeaturedImages && filterTopAreaBlocks.length > 0) {
                setFeaturedImageBlocks(getInitialFeaturedImageBlocks());
            }
        }
    }

    const handleClickOutside = (event) => {
        const isClickInside = megaMenuRef.current && megaMenuRef.current.contains(event.target);
        if (!isClickInside) {
            // @ts-ignore
            window.Alpine?.store('navigation').setMenuId(null);
            setHoveredLink(null);
            closeMenu();
        }
    };

    const handleLinkHover = (event) => {
        const allowedClasses = [
            'megamenu__link',
            'megamenu__link-container--inner',
            'megamenu-nav-list',
            'megamenu-nav',
            'menu-link__link',
            'menu-link',
            'header-container',
            'header-menu',
        ];

        const isHoveringOnLink = allowedClasses.some((className) =>
            event.target.classList.contains(className)
        );

        // console.log('Hovered Classes:', event.target.classList, 'Is Hovering:', isHoveringOnLink);

        if (!isHoveringOnLink) {
            // Clear hovered link and close the menu
            setHoveredLink(null);
            window.Alpine?.store('navigation').setMenuId(null);
        } else {
            // Optionally open the menu if required
            // openMenu('MEGAMENU');
        }
    };


    // Function to add active class based on handle
    function setActiveLink(handle) {

        const activeLink = document.querySelector(
            ".megamenu__link-container.active",
        );

        if (activeLink) {
            activeLink.classList.remove("active");

        }

        const linkDiv = document.querySelector(`li[data-link-id='${handle}']`);
        if (linkDiv) {
            // Add the active class
            linkDiv.classList.add("active");
        }
    }

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("mouseover", handleLinkHover);
        // openMenu('MEGAMENU');
        return () => {
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("mouseover", handleLinkHover);
            setFeaturedImageBlocks(getInitialFeaturedImageBlocks());
            // element.removeEventListener('animationend', handleAnimationEnd);
        };
    }, [ref]);

    return {
        menuState,
        menuItems,
        updateMenuState,
        handleFirstLevelClick,
        handleBackClick,
        handleMenuClose,
        onLinkHover,
        getPadding,
        hoveredLink,
        megaMenuRef,
        firstLevelLinks,
        secondLevelLinks,
        featuredImageBlocks,
        setFeaturedImageBlocks
    };
}

export default useMegamenu;
